"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anonymizeResumeHash = anonymizeResumeHash;
const RESUMEHASH_REGEX = /resumeHash=[^&]*/g;
const XED_OUT_RESUMEHASH = 'resumeHash=xxxxxxxxxxxxxxx';
function anonymizeResumeHash(urlPart) {
    if (!urlPart)
        return urlPart;
    return urlPart.replace(RESUMEHASH_REGEX, XED_OUT_RESUMEHASH);
}
//# sourceMappingURL=anonymizeResumeHash.js.map